import {
  Plugin,
} from 'ckeditor5';
import EditorStateEditing from 'views/EMR/components/ckeditor-plugins/EditorState/editing';

export default class EditorState extends Plugin {
  static get requires() {
    return [EditorStateEditing] as const;
  }

  static get pluginName() {
    return 'EditorState' as const;
  }
}
